import { PartialType } from '@nestjs/swagger';
import { CreateCondicionPagoDto } from './create-condicion-pago.dto';

export class UpdateCondicionPagoDto extends PartialType(CreateCondicionPagoDto) {}
